import { render } from "./PanelComponent.vue?vue&type=template&id=079553f7&scoped=true"
import script from "./PanelComponent.vue?vue&type=script&lang=js"
export * from "./PanelComponent.vue?vue&type=script&lang=js"

import "./PanelComponent.vue?vue&type=style&index=0&id=079553f7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079553f7"]])

export default __exports__